import {AnswerMapperJrpc} from '../../../../core/domain/Answer/mappers/jrpc/Answer.mapper.jrpc';
import {AppEventMapperJrpc} from '../../../../core/domain/AppEvent/mappers/AppEvent.mapper.jrpc';
import {ArticleExpandJrpc} from '../../../../core/domain/Article/mappers/Article.expand.jrpc';
import {ArticleMapperJrpc} from '../../../../core/domain/Article/mappers/Article.mapper.jrpc';
import {AssessmentExpandJrpc} from '../../../../core/domain/Assessment/mappers/jrpc/Assessment.expand.jrpc';
import {AssessmentMapperJrpc} from '../../../../core/domain/Assessment/mappers/jrpc/Assessment.mapper.jrpc';
import {BoundAssessmentExpandJrpc} from '../../../../core/domain/BoundAssessment/mappers/jrpc/BoundAssessment.expand.jrpc';
import {BoundAssessmentMapperJrpc} from '../../../../core/domain/BoundAssessment/mappers/jrpc/BoundAssessment.mapper.jrpc';
import {CardExpandJrpc} from '../../../../core/domain/Card/mappers/Card.expand.jrpc';
import {CardMapperJrpc} from '../../../../core/domain/Card/mappers/Card.mapper.jrpc';
import {CategoryExpandJrpc} from '../../../../core/domain/Category/mappers/Category.expand.jrpc';
import {CategoryMapperJrpc} from '../../../../core/domain/Category/mappers/Category.mapper.jrpc';
import {CoachHistoryExpandJrpc} from '../../../../core/domain/CoachHistory/mappers/CoachHistory.expand.jrpc';
import {CoachHistoryMapperJrpc} from '../../../../core/domain/CoachHistory/mappers/CoachHistory.mapper.jrpc';
import {PaymentPlanMapperJrpc} from '../../../../core/domain/common/PaymentPlan/mappers/PaymentPlan.mapper.jrpc';
import {PrivateProfileMapperJrpc} from '../../../../core/domain/common/PrivateProfile/mappers/PrivateProfile.mapper.jrpc';
import {UserAdditionalDataMapperJrpc} from '../../../../core/domain/common/UserAdditionalData/mappers/UserAdditionalData.mapper.jrpc';
import {ConferenceExpandJrpc} from '../../../../core/domain/Conference/mappers/Conference.expand.jrpc';
import {ConferenceMapperJrpc} from '../../../../core/domain/Conference/mappers/Conference.mapper.jrpc';
import {CouponExpandJrpc} from '../../../../core/domain/Coupon/mappers/Coupon.expand.jrpc';
import {CouponMapperJrpc} from '../../../../core/domain/Coupon/mappers/Coupon.mapper.jrpc';
import {CourseExpandJrpc} from '../../../../core/domain/Course/mappers/Course.expand.jrpc';
import {CourseMapperJrpc} from '../../../../core/domain/Course/mappers/Course.mapper.jrpc';
import {DateTimeMapperJrpc} from '../../../../core/domain/Date/mappers/DateTime.mapper.jrpc';
import {EditionExpandJrpc} from '../../../../core/domain/Edition/mappers/Edition.expand.jrpc';
import {EditionMapperJrpc} from '../../../../core/domain/Edition/mappers/Edition.mapper.jrpc';
import {FileExpandJrpc} from '../../../../core/domain/File/mappers/File.expand.jrpc';
import {FileMapperJrpc} from '../../../../core/domain/File/mappers/File.mapper.jrpc';
import {FollowerExpandJrpc} from '../../../../core/domain/Follower/mappers/Follower.expand.jrpc';
import {FollowerMapperJrpc} from '../../../../core/domain/Follower/mappers/Follower.mapper.jrpc';
import {FoodDiaryExpandJrpc} from '../../../../core/domain/FoodDiary/mappers/FoodDiary.expand.jrpc';
import {FoodDiaryMapperJrpc} from '../../../../core/domain/FoodDiary/mappers/FoodDiary.mapper.jrpc';
import {GoalExpandJrpc} from '../../../../core/domain/Goal/mappers/Goal.expand.jrpc';
import {GoalMapperJrpc} from '../../../../core/domain/Goal/mappers/Goal.mapper.jrpc';
import {MembershipExpandJrpc} from '../../../../core/domain/Membership/mappers/Membership.expand.jrpc';
import {MembershipMapperJrpc} from '../../../../core/domain/Membership/mappers/Membership.mapper.jrpc';
import {MetricMapperJrpc} from '../../../../core/domain/Metric/mappers/Metric.mapper.jrpc';
import {OfferExpandJrpc} from '../../../../core/domain/Offer/mappers/Offer.expand.jrpc';
import {OfferMapperJrpc} from '../../../../core/domain/Offer/mappers/Offer.mapper.jrpc';
import {PaymentExpandJrpc} from '../../../../core/domain/Payment/mappers/Payment.expand.jrpc';
import {PaymentMapperJrpc} from '../../../../core/domain/Payment/mappers/Payment.mapper.jrpc';
import {PAYMENT_MAPPER_JRPC_IDENTIFIER} from '../../../../core/domain/Payment/mappers/Payment.mapper.jrpc.identifier';
import {ProgramExpandJrpc} from '../../../../core/domain/Program/mappers/Program.expand.jrpc';
import {ProgramMapperJrpc} from '../../../../core/domain/Program/mappers/Program.mapper.jrpc';
import {ChoiceQuestionMapperJrpc} from '../../../../core/domain/Question/ChoiceQuestion/mappers/ChoiceQuestion.mapper.jrpc';
import {QuestionMapperJrpc} from '../../../../core/domain/Question/mappers/jrpc/Question.mapper.jrpc';
import {TextQuestionMapperJrpc} from '../../../../core/domain/Question/TextQuestion/mappers/TextQuestion.mapper.jrpc';
import {RefundExpandJrpc} from '../../../../core/domain/Refund/mappers/Refund.expand.jrpc';
import {RefundMapperJrpc} from '../../../../core/domain/Refund/mappers/Refund.mapper.jrpc';
import {SubgoalExpandJrpc} from '../../../../core/domain/Subgoal/mappers/Subgoal.expand.jrpc';
import {SubgoalMapperJrpc} from '../../../../core/domain/Subgoal/mappers/Subgoal.mapper.jrpc';
import {SubtenantExpandJrpc} from '../../../../core/domain/Subtenant/mappers/Subtenant.expand.jrpc';
import {SubtenantMapperJrpc} from '../../../../core/domain/Subtenant/mappers/Subtenant.mapper.jrpc';
import {SubtenantArticlesAccessMapperJrpc} from '../../../../core/domain/Subtenant/mappers/SubtenantArticlesAccess.mapper.jrpc';
import {SubtenantExtensionConfigurationMapperJrpc} from '../../../../core/domain/Subtenant/mappers/SubtenantExtensionConfiguration.mapper.jrpc';
import {TaskExpandJrpc} from '../../../../core/domain/Task/mappers/Task.expand.jrpc';
import {TaskMapperJrpc} from '../../../../core/domain/Task/mappers/Task.mapper.jrpc';
import {TenantExpandJrpc} from '../../../../core/domain/Tenant/mappers/Tenant.expand.jrpc';
import {TenantMapperJrpc} from '../../../../core/domain/Tenant/mappers/Tenant.mapper.jrpc';
import {TENANT_MAPPER_JRPC_IDENTIFIER} from '../../../../core/domain/Tenant/mappers/Tenant.mapper.jrpc.identifier';
import {UserExpandJrpc} from '../../../../core/domain/User/mappers/User.expand.jrpc';
import {UserMapperJrpc} from '../../../../core/domain/User/mappers/User.mapper.jrpc';
import {UserMetadataMapperJrpc} from '../../../../core/domain/User/UserMetadata/mappers/UserMetadata.mapper.jrpc';
import {UserOnboardingMapperJrpc} from '../../../../core/domain/User/UserOnboarding/mappers/UserOnboarding.mapper.jrpc';
import {WaitlistItemExpandJrpc} from '../../../../core/domain/WaitlistItem/mappers/WaitlistItem.expand.jrpc';
import {WaitlistItemMapperJrpc} from '../../../../core/domain/WaitlistItem/mappers/WaitlistItem.mapper.jrpc';
import {WsMessageExpandJrpc} from '../../../../core/domain/WsMessage/mappers/WsMessage.expand.jrpc';
import {WsMessageMapperJrpc} from '../../../../core/domain/WsMessage/mappers/WsMessage.mapper.jrpc';
import {FetchCardsListQuery} from '../../../../core/ports/Card/FetchCardsList/FetchCardsList.query';
import {FetchCardsListQueryJrpc} from '../../../../core/ports/Card/FetchCardsList/jrpc/FetchCardsList.query.jrpc';
import {FetchCategoriesQuery} from '../../../../core/ports/Category/FetchCategories/FetchCategories.query';
import {FetchCategoriesQueryJrpc} from '../../../../core/ports/Category/FetchCategories/jrpc/FetchCategories.query.jrpc';
import {CreateCourseCmd} from '../../../../core/ports/Course/CreateCourse/CreateCourse.cmd';
import {CreateCourseCmdJrpc} from '../../../../core/ports/Course/CreateCourse/jrpc/CreateCourse.cmd.jrpc';
import {FetchCourseQuery} from '../../../../core/ports/Course/FetchCourse/FetchCourse.query';
import {FetchCourseQueryJrpc} from '../../../../core/ports/Course/FetchCourse/jrpc/FetchCourse.query.jrpc';
import {ReadFileQueryJrpc} from '../../../../core/ports/File/ReadFile/jrpc/ReadFile.query.jrpc';
import {ReadFileQuery} from '../../../../core/ports/File/ReadFile/ReadFile.query';
import {UploadFileCmdJrpc} from '../../../../core/ports/File/UploadFile/jrpc/UploadFile.cmd.jrpc';
import {UploadFileCmd} from '../../../../core/ports/File/UploadFile/UploadFile.cmd';
import {FetchFollowersListByUserIdQuery} from '../../../../core/ports/Follower/FetchFollowersListByUserId/FetchFollowersListByUserId.query';
import {FetchFollowersListByUserIdQueryJrpc} from '../../../../core/ports/Follower/FetchFollowersListByUserId/jrpc/FetchFollowersListByUserId.query.jrpc';
import {CreateGoalsInCourseCmd} from '../../../../core/ports/Goal/CreateGoalsInCourse/CreateGoalsInCourse.cmd';
import {CreateGoalsInCourseCmdJrpc} from '../../../../core/ports/Goal/CreateGoalsInCourse/jrpc/CreateGoalsInCourse.cmd.jrpc';
import {FetchUnboundGoalsQuery} from '../../../../core/ports/Goal/FetchUnboundGoals/FetchUnboundGoals.query';
import {FetchUnboundGoalsQueryJrpc} from '../../../../core/ports/Goal/FetchUnboundGoals/jrpc/FetchUnboundGoals.query.jrpc';
import {FetchMembershipListQuery} from '../../../../core/ports/Membership/FetchMembershipList/FetchMembershipList.query';
import {FetchMembershipListQueryJrpc} from '../../../../core/ports/Membership/FetchMembershipList/jrpc/FetchMembershipList.query.jrpc';
import {ToggleEmployeeSubscriptionCmdJrpc} from '../../../../core/ports/Membership/ToggleEmployeeSubscription/jrpc/ToggleEmployeeSubscription.cmd.jrpc';
import {ToggleEmployeeSubscriptionCmd} from '../../../../core/ports/Membership/ToggleEmployeeSubscription/ToggleEmployeeSubscription.cmd';
import {FetchMissedCromsCountQuery} from '../../../../core/ports/MissedCroms/fetchMissedCromsCount/FetchMissedCromsCount.query';
import {FetchMissedCromsCountQueryJrpc} from '../../../../core/ports/MissedCroms/fetchMissedCromsCount/jrpc/FetchMissedCromsCount.query.jrpc';
import {FetchUserQuery} from '../../../../core/ports/User/FetchUser/FetchUser.query';
import {FetchUserQueryJrpc} from '../../../../core/ports/User/FetchUser/jrpc/FetchUser.query.jrpc';
import {FetchUserWaitlistItemsQuery} from '../../../../core/ports/User/FetchUserWaitlistItems/FetchUserWaitlistItems.query';
import {FetchUserWaitlistItemsQueryJrpc} from '../../../../core/ports/User/FetchUserWaitlistItems/jrpc/FetchUserWaitlistItems.query.jrpc';
import {ContainerBinder} from '../../../ContainerBinder';

const bindMappers = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container)
    .bindSingleton(UserAdditionalDataMapperJrpc)
    .bindSingleton(UserOnboardingMapperJrpc)
    .bindSingleton(AppEventMapperJrpc)
    .bindSingleton(ArticleMapperJrpc)
    .bindSingleton(CategoryMapperJrpc)
    .bindSingleton(ConferenceMapperJrpc)
    .bindSingleton(CourseMapperJrpc)
    .bindSingleton(DateTimeMapperJrpc)
    .bindSingleton(FileMapperJrpc)
    .bindSingleton(FollowerMapperJrpc)
    .bindSingleton(MembershipMapperJrpc)
    .bindSingleton(PrivateProfileMapperJrpc)
    .bindSingleton(ProgramMapperJrpc)
    .bindSingleton(SubtenantExtensionConfigurationMapperJrpc)
    .bindSingleton(SubtenantArticlesAccessMapperJrpc)
    .bindSingleton(SubtenantMapperJrpc)
    .bindSingleton(TaskMapperJrpc)
    .bindSingleton(TENANT_MAPPER_JRPC_IDENTIFIER, TenantMapperJrpc)
    .bindSingleton(TenantMapperJrpc)
    .bindSingleton(UserMapperJrpc)
    .bindSingleton(UserMetadataMapperJrpc)
    .bindSingleton(WsMessageMapperJrpc)
    .bindSingleton(CardMapperJrpc)
    .bindSingleton(PaymentMapperJrpc)
    .bindSingleton(PAYMENT_MAPPER_JRPC_IDENTIFIER, PaymentMapperJrpc)
    .bindSingleton(RefundMapperJrpc)
    .bindSingleton(PaymentPlanMapperJrpc)
    .bindSingleton(OfferMapperJrpc)
    .bindSingleton(CoachHistoryMapperJrpc)
    .bindSingleton(AssessmentMapperJrpc)
    .bindSingleton(BoundAssessmentMapperJrpc)
    .bindSingleton(QuestionMapperJrpc)
    .bindSingleton(ChoiceQuestionMapperJrpc)
    .bindSingleton(TextQuestionMapperJrpc)
    .bindSingleton(AnswerMapperJrpc)
    .bindSingleton(WaitlistItemMapperJrpc)
    .bindSingleton(CouponMapperJrpc)
    .bindSingleton(FoodDiaryMapperJrpc)
    .bindSingleton(MetricMapperJrpc)
    .bindSingleton(GoalMapperJrpc)
    .bindSingleton(SubgoalMapperJrpc)
    .bindSingleton(EditionMapperJrpc)
    .done();
};

const bindExpands = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container)
    .bindSingleton(ArticleExpandJrpc)
    .bindSingleton(CardExpandJrpc)
    .bindSingleton(CategoryExpandJrpc)
    .bindSingleton(CoachHistoryExpandJrpc)
    .bindSingleton(ConferenceExpandJrpc)
    .bindSingleton(CourseExpandJrpc)
    .bindSingleton(FileExpandJrpc)
    .bindSingleton(FollowerExpandJrpc)
    .bindSingleton(MembershipExpandJrpc)
    .bindSingleton(OfferExpandJrpc)
    .bindSingleton(PaymentExpandJrpc)
    .bindSingleton(ProgramExpandJrpc)
    .bindSingleton(RefundExpandJrpc)
    .bindSingleton(SubtenantExpandJrpc)
    .bindSingleton(AssessmentExpandJrpc)
    .bindSingleton(BoundAssessmentExpandJrpc)
    .bindSingleton(TaskExpandJrpc)
    .bindSingleton(TenantExpandJrpc)
    .bindSingleton(UserExpandJrpc)
    .bindSingleton(WsMessageExpandJrpc)
    .bindSingleton(WaitlistItemExpandJrpc)
    .bindSingleton(CouponExpandJrpc)
    .bindSingleton(FoodDiaryExpandJrpc)
    .bindSingleton(GoalExpandJrpc)
    .bindSingleton(SubgoalExpandJrpc)
    .bindSingleton(EditionExpandJrpc)
    .done();
};

const bindPorts = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container)
    .bindSingleton(UploadFileCmd, UploadFileCmdJrpc)
    .bindSingleton(FetchCourseQuery, FetchCourseQueryJrpc)
    .bindSingleton(CreateCourseCmd, CreateCourseCmdJrpc)
    .bindSingleton(
      FetchFollowersListByUserIdQuery,
      FetchFollowersListByUserIdQueryJrpc,
    )
    .bindSingleton(FetchMembershipListQuery, FetchMembershipListQueryJrpc)
    .bindSingleton(FetchMissedCromsCountQuery, FetchMissedCromsCountQueryJrpc)
    .bindSingleton(FetchUserQuery, FetchUserQueryJrpc)
    .bindSingleton(ReadFileQuery, ReadFileQueryJrpc)
    .bindSingleton(FetchCategoriesQuery, FetchCategoriesQueryJrpc)
    .bindSingleton(FetchCardsListQuery, FetchCardsListQueryJrpc)
    .bindSingleton(
      ToggleEmployeeSubscriptionCmd,
      ToggleEmployeeSubscriptionCmdJrpc,
    )
    .bindSingleton(FetchUserWaitlistItemsQuery, FetchUserWaitlistItemsQueryJrpc)
    .bindSingleton(FetchUnboundGoalsQuery, FetchUnboundGoalsQueryJrpc)
    .bindSingleton(CreateGoalsInCourseCmd, CreateGoalsInCourseCmdJrpc)
    .done();
};

export const bindCoreAppJrpc = (container: ContainerBinder.Container) => {
  bindMappers(container);
  bindExpands(container);
  bindPorts(container);
};
